// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import qrCode from 'qrcode-npm'
import computeData from '../hoc/computeData'
import $ from 'jquery'

type Props = BasicProps & {
  style: { [string]: string },
  value: string,
  typeNumber: number
};

@computeData({ includeData: true })
export default class QrCode extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      key: 'value',
      title: '内容',
      type: 'textarea'
    },
    {
      key: 'typeNumber',
      title: '大小',
      type: 'number'
    },
    'separator',
    {
      type: 'style',
      group: 'text'
    }
  ];
  qrDiv: ?HTMLDivElement;

  setImgWithHeight = () => {
    if (this.qrDiv && this.qrDiv.children && this.qrDiv.children) {
      $(this.qrDiv.children).css({ width: '100%', height: '100%' })
    }
  };

  componentDidMount () {
    this.setImgWithHeight()
  }

  render () {
    const { visible, jsEnv } = this.props
    if (!visible) {
      return null
    }
    const { id, style, value = '', typeNumber = 4 } = this.props
    const qr = qrCode.qrcode(10, 'L')
    qr.addData(jsEnv.getString(value))
    qr.make()

    return (
      <div
        ref={ref => {
          this.qrDiv = ref
        }}
        style={style}
        id={id}
        dangerouslySetInnerHTML={{ __html: qr.createImgTag(typeNumber, 0) }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/QrCode.js